// eslint-disable-next-line no-restricted-imports
import { fromJS, List, Map, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import type { resourceKinds } from '#utils/resourceUtils';

export type FollowableResource = {
  _followed: boolean;
};

class FollowResource extends Record({
  id: '',
  resourceKind: '',
}) {}

export const createFollowResource = (props?: CreateFunctionInput<FollowResource>) =>
  props instanceof FollowResource ? props : new FollowResource(fromJS(props));

export class FollowPreferences extends Record({
  _links: Map(),
  resources: List(),
  notResources: List(),
  resourceSpecs: List(),
  version: 0,
}) {
  selfLink() {
    return this._links.getIn(['self', 'href']);
  }

  updateResource(resourceId: string, resourceKind: resourceKinds, isFollowed: boolean) {
    const followResource = createFollowResource({ id: resourceId, resourceKind });

    if (isFollowed) {
      return this.update('resources', (rs) => rs.push(followResource)).update('notResources', (rs) =>
        rs.filter((r) => r.id !== followResource.id),
      );
    }

    return this.update('notResources', (rs) => rs.push(followResource)).update('resources', (rs) =>
      rs.filter((r) => r.id !== followResource.id),
    );
  }
}

export const createFollowPreferences = (props = {}) => {
  const prefs = props instanceof FollowPreferences ? props : new FollowPreferences(props);
  return prefs
    .update('resources', (rs) => rs.map(createFollowResource))
    .update('notResources', (rs) => rs.map(createFollowResource));
};
